import { NavLink } from "react-router-dom";
import { AsoloopLogo } from "@/components/brand/AsoloopLogo";
import { cn } from "@/lib/utils";
import UserMenu from "@/components/auth/UserMenu";
import { useSelectedAppContext } from "@/lib/useSelectedAppContext";

/**
 * Slim header for the /onboarding route.
 *
 * The full `<Header />` chrome doesn't fit the onboarding flow — the
 * Apps tree is empty, the Mode badge has no app to bind to, and the
 * notification bell links into a surface gated on app selection. But
 * users still need access to sign-out + the brand mark.
 *
 * Source: production-readiness gap closed 2026-05-09 — pre-fix the
 * onboarding shell rendered no sign-out affordance, leaving freshly
 * signed-up users without a clean way to switch accounts.
 */

export default function OnboardingHeader() {
  const { userDisplayName } = useSelectedAppContext();

  return (
    <header
      className={cn(
        "flex h-14 items-center justify-between gap-4 border-b border-divider bg-surface px-4",
      )}
    >
      <NavLink
        to="/"
        aria-label="ASOLOOP home"
        className="flex items-center text-ink"
      >
        <AsoloopLogo className="text-xl" />
      </NavLink>
      <UserMenu displayName={userDisplayName} hideSettings />
    </header>
  );
}
